import styled from 'styled-components';
import Icon from 'components/Icon';

export const FormFieldStyled = styled.div`
  font-size: ${props =>
    props.theme.font.size[props.size] || props.theme.font.size.default};
  position: relative;
  opacity: ${props => props.disabled && '.5'};
`;

export const LabelStyled = styled.label`
  font-weight: ${props => props.theme.font.weight.xbold};
  color: ${props => props.theme.color.wfGrey900};
  margin-bottom: ${props => props.theme.spacing.small};
  display: block;
`;

export const InputStyled = styled.input`
  width: 100%;
  font-weight: ${props =>
    props.variant === 'secondary'
      ? props.theme.font.weight.xbold
      : props.theme.font.weight.regular};
  color: ${props => props.theme.color.wfGrey900};
  border: 1px solid ${props => props.theme.color.wfGrey300};
  border-radius: ${props => (props.rounded ? '30px' : '2px')};
  padding: ${props =>
    props.size === 'xsmall' ? '0.25rem 0.5rem' : '0.75em 0.85em'};
  background-color: ${props =>
    props.variant === 'secondary'
      ? props.theme.color.wfGrey100
      : props.theme.color.wfWhite};
  ::placeholder {
    font-weight: ${props => props.theme.font.weight.regular};
    color: ${props => props.theme.color.wfGrey400};
    text-rendering: geometricPrecision;
  }
  &:focus {
    border-color: ${props =>
      props.variant === 'primary' && props.theme.color.wfGrey500};
  }
  &:hover {
    cursor: ${props => props.disabled && 'not-allowed'};
  }
`;

export const IconStyled = styled(Icon).attrs(props => ({
  colorPath: props.theme.color.grey,
}))`
  position: absolute;
  top: ${props => (props.hasLabel ? '60%' : '50%')};
  transform: ${props => `translateY(${!props.hasLabel && '-50%'})`};
  right: 0.85em;
`;
